export default "__VITE_ASSET__CFbermo6__"